import PropTypes from 'prop-types';
import * as React from 'react';
import Modal from '../';
import { GENERAL } from '../../../intercom/intercom-data-targets';
import Button, { ButtonKind, KINDS } from '../../Button';
import { DeprecatedButtonContainer } from '../../ButtonContainer';
import SIZES, { ModalSize } from '../sizes';
import styles from './style.m.less';

export interface ConfirmModalProps {
    confirmKind?: ButtonKind;
    onClose: () => void;
    onConfirm: () => void;
    onCancel?: () => void;
    confirmLabel?: React.ReactNode;
    cancelLabel?: React.ReactNode;
    isOpen?: boolean;
    title?: React.ReactNode;
    body?: React.ReactNode;
    size?: ModalSize;
    noCloseIcon?: boolean;
    autoFocusConfirmButton?: boolean;
    disabled?: boolean;
}

export function ConfirmModal({
    confirmKind = 'PRIMARY',
    onClose,
    onConfirm,
    onCancel = () => {},
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    isOpen = false,
    title,
    body,
    size = 'MD_WIDTH',
    noCloseIcon = true,
    autoFocusConfirmButton = true,
    disabled = false,
}: ConfirmModalProps) {
    return (
        <Modal
            isOpen={isOpen}
            size={size}
            title={title}
            noCloseIcon={noCloseIcon}
            className={styles.container}
            onClose={onClose}
        >
            <div className={styles.body}>{body}</div>
            <DeprecatedButtonContainer className={styles.buttonContainer}>
                <Button
                    onClick={() => {
                        onCancel();
                        onClose();
                    }}
                >
                    {cancelLabel}
                </Button>
                <Button
                    kind={confirmKind}
                    disabled={disabled}
                    onClick={() => {
                        onConfirm();
                        onClose();
                    }}
                    autoFocus={autoFocusConfirmButton}
                    data-intercom-target={GENERAL.SHARE_BUTTON_CONFIRM_MODAL}
                >
                    {confirmLabel}
                </Button>
            </DeprecatedButtonContainer>
        </Modal>
    );
}

ConfirmModal.propTypes = {
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    confirmKind: PropTypes.oneOf(KINDS),
    confirmLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    isOpen: PropTypes.bool,
    title: PropTypes.node,
    body: PropTypes.node,
    size: PropTypes.oneOf(Object.keys(SIZES)),
    noCloseIcon: PropTypes.bool,
    autoFocusConfirmButton: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default ConfirmModal;
